import { Navigate } from "react-router-dom";
import { useAuth } from "./ProtectedRoutes";
import Loader from "../../containers/Loader/Loader";

export default function StudentOnly({ children }) {
    const { access } = useAuth();
    if(!access) return <Loader/>;
    if(access !== "student") {
        if(access === "admin") {
            return <Navigate to="/admin-panel" replace />;
        }
        return <Navigate to="/login-page" replace />;
    }
    return children;
}
